// @flow
import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';

import LoginComponent from '../components/common/Login';

import chromeComponent from '../hoc/chromeComponent';

import styles from './Login.css';
import { CHROME_CLEAN_LINKS, META_TITLE_PREFIX } from '../constants';
import protectedComponent from '../hoc/protectedComponent';
import { defineMessages } from 'react-intl';
import * as clientActions from '../actions/client';

const messages = defineMessages({
  metaTitle: {
    id: 'login.meta-title',
    defaultMessage: 'Login',
  },
});

const Login = () => {
  const classesView = classnames(styles.view, 'u-page-container');

  return (
    <div className={classesView}>
      <LoginComponent showFacebookLogin />
    </div>
  );
};

Login.onDataFetch = (store, params, location, intl) => {
  store.dispatch(
    clientActions.setHelmet({
      title: META_TITLE_PREFIX + intl.formatMessage(messages.metaTitle),
      canonicalRoute: '/login',
    })
  );
};

export default compose(
  protectedComponent({ anonymousOnly: true }),
  chromeComponent({ type: CHROME_CLEAN_LINKS })
)(Login);
